__turbopack_context__.v({
  "lottie-container": "AcfLottie-module-scss-module__Penaiq__lottie-container",
});
